import axios from "axios";

const baseURL = "https://api.plantgenie.org/plugins";

const axiosClient = axios.create({ baseURL: baseURL });

// API-based data fetching (legacy)
export async function getExImageData(experiment, gene) {
  return axiosClient.get(
    "/eximage/service/eplant_service.php?primaryGene=" +
    gene +
    "&view=" +
    experiment
  );
}

// Neo4j-based data fetching
export async function getExImageDataFromNeo4j(driver, database, experiment, gene) {
  // Map experiment names to Neo4j labels and relationships
  const experimentMapping = {
    exatlas: { label: "EXATLAS", relationship: "EXATLAS_EXPRESSION" },
    aspwood: { label: "ASPWOOD", relationship: "ASPWOOD_EXPRESSION" },
    leaf_development: { label: "LEAF_DEV", relationship: "LEAF_DEV_EXPRESSION" },
    sex: { label: "SEX", relationship: "SEX_EXPRESSION" },
  };

  const config = experimentMapping[experiment];
  if (!config) {
    throw new Error(`Unknown experiment: ${experiment}`);
  }

  const query = `
    MATCH (g:Gene {name: $geneName})-[:${config.relationship}]->(e:${config.label})
    WHERE e.sample_name IS NOT NULL OR e.tissue_name IS NOT NULL
    RETURN 
      CASE WHEN e.sample_name IS NOT NULL THEN e.sample_name ELSE e.tissue_name END AS sample, 
      e.expression AS log2,
      e.expression AS rmd,
      e.expression AS log2fc
    ORDER BY e.sample_i
  `;

  const session = database
    ? driver.session({ database: database })
    : driver.session();

  try {
    const result = await session.run(query, { geneName: gene });

    // Transform Neo4j result to match API format
    const popdata = result.records.map((record) => ({
      sample: record.get("sample"),
      log2: String(record.get("log2")),
      rmd: String(record.get("rmd")),
      log2fc: String(record.get("log2fc")),
    }));

    // Return in format matching API response (with "sspopuser" prefix)
    return {
      data: "sspopuser" + JSON.stringify({ popdata }),
    };
  } finally {
    await session.close();
  }
}

export async function getImageData() {
  return axios.get(
    "https://api.plantgenie.org/plugins/eximage/svg/potra/exatlas.svg"
  );
}
